import * as client from '../../services/client';
import { TYPES, ErrorMessages } from 'src/common/constants';
import { selectSuiteById } from '../selectors/suites';
import { PATHS } from 'src/common/constants';
import {
  stopLoading,
  startPRLoading,
  stopPRLoading,
  startFormLoading,
  stopFormLoading,
} from '../actions/loader';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { fetchSuiteWalkThroughs } from './walkThroughs';
import { fetchCountsDone } from './properties';
import moment from 'moment';
import { store } from '..';

const fetchPropertySuitesDone = (payload) => ({
  type: TYPES.FETCH_PROPERTY_SUITES_DONE,
  payload,
});

export const fetchPropertySuites = (id, userId, role, loader) => (dispatch) => {
  if (loader === false) {
  } else {
    dispatch(startPRLoading());
  }
  return client
    .getIndividualPropertySuiteByID(id, userId, role)
    .then((response) => {
      if (response.status === 200) {
        response.json().then((responsejson) => {
          dispatch(fetchPropertySuitesDone(responsejson));
          dispatch(stopPRLoading());
        });
      } else if (response.status === 204) {
        dispatch(fetchPropertySuitesDone([]));
        dispatch(stopPRLoading());
      } else {
        dispatch(stopPRLoading());
      }
    });
};

export const clearValidation = () => ({
  type: TYPES.CLEAR_VALIDATION,
});

const deleteUnitDone = (payload) => ({
  type: TYPES.DELETE_UNIT_DONE,
  payload,
});

export const deleteUnit = (id, userId, history, property) => (dispatch) => {
  dispatch(startFormLoading());
  return client.deleteUnit(id, userId).then((response) => {
    dispatch(stopFormLoading());
    if (response.ok || response.status === 200) {
      toast.success(' ⓘ Unit has been deleted.', {
        autoClose: 10000,
        position: 'top-center',
      });
      if (history) {
        history.push({
          pathname: PATHS.PROPERTIES_VIEW.replace(':id', property.id),
          state: { data: property },
        });
      }
      dispatch(deleteUnitDone(id));
    } else {
    }
  });
};

export const clearSuites = () => ({
  type: TYPES.CLEAR_SUITES,
});

const fetchSuiteByIdDone = (payload) => ({
  type: TYPES.FETCH_SUITE_BY_ID_DONE,
  payload,
});

export const fetchSuiteById = (id) => (dispatch, getState) => {
  const suite = selectSuiteById(getState(), id);
  if (!suite) {
    return client
      .getSuiteById(id)
      .then((response) => dispatch(fetchSuiteByIdDone(response.data)));
  }
};

const fetchSuiteAreasDone = (payload) => ({
  type: TYPES.FETCH_SUITE_AREAS_DONE,
  payload,
});

export const fetchSuiteAreas = () => (dispatch) => {
  return client.getSuiteAreas().then((response) => {
    if (response.ok) {
      response.json().then((responsejson) => {
        let other = responsejson.filter((area) => area.name === 'Other');
        responsejson = responsejson.filter((area) => area.name !== 'Other');
        responsejson = [...responsejson, ...other];

        dispatch(fetchSuiteAreasDone(responsejson));
      });
    } else {
      dispatch(fetchSuiteAreasDone([]));
    }
  });
};

export const setWalkThroughStatus = (status, data) => (dispatch) => {
  status = { ...status, ReviewDate: moment().format('MM-DD-YYYY HH:mm:ss') };
  return client
    .setWalkThroughStatus(status)
    .then((response) => {
      if (response.ok || response.status === 200) {
        response.json().then((responsejson) => {
          if (responsejson.statusCode === 200) {
            if (status.Status === 'Review') {
              dispatch(fetchSuiteCounts(status.SuiteId));
              toast.success(
                'ⓘ  Congratulations! You have successfully completed the walk-through, We will send an email notification once the PDF is ready for your review.',
                { autoClose: 3000, position: 'top-center' }
              );
            }
            let state = store.getState();
            const userData = state.auth?.user || {};
            const roleName = userData.roles[0].role.name;
            dispatch(fetchSuiteWalkThroughs(status.SuiteId, roleName));
          } else {
            toast.error(
              ' 🚫 Walkthrough status updating failed, please try again.',
              { autoClose: 3000, position: 'top-center' }
            );
          }
        });
      } else {
        toast.error(' 🚫 Something went wrong, please try again.', {
          autoClose: 3000,
          position: 'top-center',
        });
      }
    })
    .catch(() => {
      toast.error(' 🚫 Something went wrong, please try again.', {
        autoClose: 3000,
        position: 'top-center',
      });
    });
};

export const clearSuiteUsers = () => ({
  type: TYPES.CLEAR_SUITE_USERS,
});

export const fetchSuiteCounts = (suiteId, role) => (dispatch) => {
  return client.fetchSuiteCounts(suiteId, role).then((response) => {
    if (response.status === 200 || response.ok) {
      response.json().then((responsejson) => {
        if (responsejson.statusCode === 200) {
          dispatch(fetchCountsDone(responsejson.data));
        }
      });
    }
  });
};

export const onClearMoreDetails = () => (dispatch) => {
  dispatch({
    type: TYPES.CLEAR_MORE_DETAILS_DONE,
  });
};

export const onFetchContactMoreDetails = (id) => (dispatch) => {
  dispatch({
    type: TYPES.IS_FETCH_MORE_DETAILS_LOADING,
  });
  client
    .onFetchContactMoreDetails(id)
    .then((response) => {
      dispatch(stopLoading());
      if (response.status === 200) {
        response.json().then((responseJson) => {
          dispatch({
            type: TYPES.FETCH_MORE_DETAILS_DONE,
            payload: responseJson,
          });
        });
      } else {
        dispatch({
          type: TYPES.CLOSE_FETCH_MORE_DETAILS_LOADING,
        });
      }
    })
    .catch((error) => {
      dispatch({
        type: TYPES.CLOSE_FETCH_MORE_DETAILS_LOADING,
      });
    });
};

export const onClearResponseDone = () => (dispatch) => {
  dispatch({
    type: TYPES.CLEAR_RESPONSE_DONE,
  });
};